export default __webpack_public_path__ + "static/media/InCN.8acb7519.png";